export default "__VITE_ASSET__CqncXjCf__"